import axiosClient from "../api/axiosClient";

export const getMyProfile = async () => {
  const res = await axiosClient.get("/me");
  return res.data;
};

export const updateMyProfile = async (payload: any) => {
  const response = await axiosClient.put("/admin/1", payload);
  return response.data;
};

export type RawProfile = {
  profile_id: number;
  login_id: number;
  profile_photo: string | null;
  sign_photo: string | null;
  employee_code: string | null;
  customer_code: string | null;
  first_name: string | null;
  last_name: string | null;
  phone: string | null;
  created_at: string | null;
  updated_at: string | null;
  email?: string;
  mobile_number?: string;
  login?: {
    login_id: number;
    username?: string;

    role?: string;
    status?: string;
  };
  address_bank_details?: any[]; 
  loans?: any[];
  [k: string]: any;
};

export type ProfilesResponse = {
  total: number;
  profiles: RawProfile[];
};

export const getProfiles = async (params?: Record<string, any>) => {
  const res = await axiosClient.get<ProfilesResponse>("/profiles", { params });
  return res.data;
};

export const getProfileById = async (id: number) => {
  const res = await axiosClient.get<{ type?: string; profile: RawProfile }>(`/profiles/${id}`);
  return res.data;
};

export async function addProfile(data: any) {
  const toFormData = (obj: any) => {
    if (obj instanceof FormData) return obj;
    const fd = new FormData();
    Object.entries(obj || {}).forEach(([key, value]) => {
      if (value === null || value === undefined) return;
      if (value instanceof FileList && value.length > 0) {
        fd.append(key, value[0]);
      } else if (value instanceof File) {
        fd.append(key, value);
      } else if (Array.isArray(value)) {
        fd.append(key, JSON.stringify(value));
      } else if (typeof value === "object") {
        fd.append(key, JSON.stringify(value));
      } else {
        fd.append(key, value.toString());
      }
    });
    return fd;
  };

  const fd = toFormData(data);
  const res = await axiosClient.post("/profiles", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
}

export const updateProfile = async (id: number | string, payload: any) => {
  const toFormData = (obj: any) => {
    if (obj instanceof FormData) return obj;
    const fd = new FormData();
    Object.entries(obj || {}).forEach(([key, value]) => {
      if (value === null || value === undefined) return;
      if (value instanceof FileList && value.length > 0) {
        fd.append(key, value[0]);
      } else if (value instanceof File) {
        fd.append(key, value);
      } else if (Array.isArray(value)) {
        fd.append(key, JSON.stringify(value));
      } else if (typeof value === "object") {
        fd.append(key, JSON.stringify(value));
      } else {
        fd.append(key, value.toString());
      }
    });
    return fd;
  };

  const fd = toFormData(payload);
  // Use POST with method override to support multipart updates consistently
  if (!fd.has("_method")) fd.append("_method", "PUT");
  const res = await axiosClient.post(`/profiles/${id}`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const deleteProfile = async (id: string | number) => {
  const res = await axiosClient.delete(`/profiles/${id}`);
  return res.data;
};

export const addAddressBank = async (id: number | string, payload: any) => {
  const res = await axiosClient.post(`/profiles/${id}/address-bank`, payload);
  return res.data;
};
export const updateAddressBank = async (profileId: number | string, addressId: number | string, payload: any) => {
  const res = await axiosClient.put(`/address-bank/${addressId}`, payload);
  return res.data;
};
export const deleteAddressBank = async (addressId: number | string) => {
  const res = await axiosClient.delete(`/address-bank/${addressId}`);
  return res.data;
};